import './styles.scss';

import { ReactElement, useEffect } from 'react';

import { DATE_FE_FORMAT } from '@/constants';
import { Dayts } from '@/utils';
import DriveTimeDeviations from '@/features/DriveTimeTool/components/DriveTimeDeviations';
import DriveTimeScatterPlot from '@/features/DriveTimeTool/components/DriveTimeScatterPlot';
import SkyhopPdfHeader from '@/features/PdfLayout/components/SkyhopPdfHeader';
import TimeIntervalStats from '@/features/DriveTimeTool/components/TimeIntervalStats';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useDriveTimeTool } from '@/features/DriveTimeTool';
import { usePdfLayout } from '@/features/PdfLayout';
import { useSearchParams } from 'react-router-dom';

export type DriveTimePdfProps = { id: string };

const DriveTimePdf = ({ id }: DriveTimePdfProps): ReactElement => {
  useDocumentTitle('Drive Time Report');
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const puLocation = searchParams.get('puLocation');
  const doLocation = searchParams.get('doLocation');
  const date = searchParams.get('date');
  const setState = usePdfLayout(({ setState }) => setState);
  const setDriveTimeTool = useDriveTimeTool(({ setState }) => setState);

  useEffect(() => {
    // reset to default state on component unmount
    setDriveTimeTool({
      loading: {
        history: false,
        locations: false,
        intervals: false,
        scatterPlot: false,
        deviations: false,
      },
      history: [],
      locations: new Map(),
      groupedLocationIdsByAddress: new Map(),
      selected: id,
      selectedFrom: (type as 'manifestHistoryRouteId' | 'queryHistoryId') || 'queryHistoryId',
      timeFrameId: null,
      showTimeFrameModal: false,
      expandHistory: false,
    });
    setState((current) => ({ ...current, loading: false }));
  }, [id, setDriveTimeTool, setState, type]);

  return (
    <div className="DriveTimePdf">
      <SkyhopPdfHeader src="/public/assets/images/svgviewer-png-output.png">
        <div className="Title">Drive Time Report</div>
        <div className="Subtitle">
          {puLocation} to {doLocation} {date && `· ${new Dayts(date).format(DATE_FE_FORMAT)}`}
        </div>
      </SkyhopPdfHeader>
      <div className="DriveTimePdf-Content">
        <div className="DriveTimeTool-TimeIntervalStats">
          <TimeIntervalStats />
        </div>
        <div className="DriveTimeTool-Chart">
          <DriveTimeScatterPlot height="3.33in" title="DRIVE TIME OUTLIERS" />
        </div>
        <div className="DriveTimeTool-Chart">
          <DriveTimeDeviations height="3.33in" title="DEVIATIONS" disableMiniMap />
        </div>
      </div>
    </div>
  );
};

export default DriveTimePdf;
